import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/img/protractor_logo_rev.svg'


const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "storename"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "signature" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Powered by"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: "Protractor"
  })
], -1)

import { useAuth0 } from '@auth0/auth0-vue';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  name: 'Signature',
  setup(__props) {

const store = useStore();
const router = useRouter();
const auth0 = useAuth0();
const isAuthenticated = ref(auth0.isAuthenticated);
const storename = computed(() => store.state.storename);
const user = ref(auth0.user);
const userRole = computed(() => user.value['http://protractor.com/role']);

const dvipages = ['/dviworkorders', '/dviworkorderpackages', '/dviupdateworkorderpackage', '/dvisummaryworkorderpackage', '/results.html'];
const vinscannerpages = ['/workorders', '/updateorder'];
const reportingpages = ['/reporting', '/reports'];
const enterprisereportpages = ['/enterprise'];

const isVINScannerPage = computed(() => vinscannerpages.includes(router.currentRoute.value.path));
const isDVIPage = computed(() => dvipages.includes(router.currentRoute.value.path));
const isReportingPage = computed(() => reportingpages.includes(router.currentRoute.value.path));
const isEnterpriseReportPage = computed(() => enterprisereportpages.includes(router.currentRoute.value.path));
const isEnterpriseAdmin = computed(() => userRole.value === 'EnterpriseAdmin');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isAuthenticated.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            (_unref(isEnterpriseAdmin) && !_unref(isEnterpriseReportPage))
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(storename)), 1))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("h2", null, "VIN Scanner", 512), [
              [_vShow, _unref(isVINScannerPage)]
            ]),
            _withDirectives(_createElementVNode("h2", null, "Digital Vehicle Inspection", 512), [
              [_vShow, _unref(isDVIPage)]
            ]),
            _withDirectives(_createElementVNode("h2", null, "Reporting", 512), [
              [_vShow, _unref(isReportingPage)]
            ]),
            _withDirectives(_createElementVNode("h2", null, "Enterprise Reports", 512), [
              [_vShow, _unref(isEnterpriseAdmin) && _unref(isEnterpriseReportPage)]
            ])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _withDirectives(_createElementVNode("h2", null, "Digital Vehicle Inspection", 512), [
              [_vShow, _unref(isDVIPage)]
            ])
          ]))
    ]),
    _hoisted_6
  ]))
}
}

})